import { t } from 'i18next';
import { TKeystoneAffix, TClientAffixData } from '../../types/keystoneAffixTypes';

export const getAffixName = (affix: TKeystoneAffix | TClientAffixData, locale?: string): string => {
  if ('name' in affix && typeof affix.name === 'string') {
    return affix.name;
  }

  if ('name' in affix && affix.name && typeof affix.name === 'object') {
    const nameByLocale = affix.name as Record<string, string | undefined>;
    return nameByLocale[locale ?? 'en'] ?? nameByLocale.en ?? t(`affixes:${affix.id}.name`, { lng: locale });
  }

  return t(`affixes:${affix.id}.name`, { lng: locale });
};
